<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    :rules="rules"
    :value="value"
    @input="onInput"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import constants from "../../../helpers/constants";

export default {
  name: "DataTypePicker",

  props: ["title", "isRequired", "value"],

  data() {
    return {
      fields: [
        constants.DATA_TYPE_NUMBER,
        constants.DATA_TYPE_TEXT,
        constants.DATA_TYPE_DATE,
        constants.DATA_TYPE_BOOL,
      ],
    };
  },

  computed: {
    rules() {
      return this.isRequired
        ? ui.requiredRules(this.$store.getters.required)
        : [];
    },
  },

  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
  },
};
</script>